import React, { useState } from 'react';
import './PrivacyPage.css';

import { faLongArrowAltLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from 'components/Modal/Modal';
import { useHistory } from 'react-router-dom';
import { usePrivacyContext } from 'contexts/PrivacyContext';
import { LoadingHU } from 'components/LoadingHU';

export default function PrivacyPage() {
  const { isSharing, denyConsentSharing, allowConsentSharing, privacyLoading } =
    usePrivacyContext();
  const [showModal, setShowModal] = useState(null);
  const history = useHistory();

  const [modalTitle, setModalTitle] = useState('');
  const [modalBodyText, setModalBodyText] = useState('');

  function handleNotSharingEvent() {
    setShowModal(true);

    setModalTitle('Desativar Compartilhar Registo Eletrônico de Saúde');
    setModalBodyText(
      'Você tem certeza que deseja desativar o compartilhamento do seu registro eletrônico de saúde?',
    );
  }

  function handleSharingEvent() {
    setShowModal(true);

    setModalTitle('Compartilhar Registo Eletrônico de Saúde');
    setModalBodyText(
      'Você tem certeza que deseja compartilhar seu registro eletrônico de saúde?',
    );
  }

  // TODO: primeira vez que fecha, atualiza o estado isSharing (o q nao deve acontecer)
  function handleModalClose() {
    setShowModal(false);
  }

  async function handleModalSubmit() {
    setShowModal(false);
    if (isSharing) await denyConsentSharing();
    else await allowConsentSharing();
  }

  return (
    <>
      <Modal
        title={modalTitle}
        bodyText={modalBodyText}
        show={showModal}
        onClose={handleModalClose}
        onSubmit={handleModalSubmit}
      />
      {isSharing === null || privacyLoading ? <LoadingHU state /> : <></>}
      <div className="containerPrivacy">
        <div className="headerPrivacy">
          <h1 className="pageTitle">Privacidade</h1>
        </div>
        <div className="subtitlePrivacy">Informações de Compartilhamentos</div>
        <div className="contentTextPrivacy">
          <p className="firstParagraphPrivacy">
            Ao aceitar os termos de uso deste aplicativo e caso você já tenha
            sido atendido em alguma unidade de saúde participante da Plataforma
            HU Digital, por padrão, seu Registro Eletrônico de Saúde é
            compartilhado automaticamente entre as unidades de saúde.
          </p>
          <p className="middleParagraphPrivacy">
            O compartilhamento do Registro Eletrônico de Saúde é importante para
            a continuidade do seu cuidado de saúde, ao compartilha-lo, suas
            informações de saúde já estarão disponíveis para os profissionais
            das diferentes unidades de saúde participantes da rede dos Hospitais
            Universitários Federais do (HU Brasil), proporcionando um
            atendimento mais humanizado.
          </p>
          <p className="middleParagraphPrivacy">
            Você pode gerenciar quais as unidades de saúde ou as pessoas
            próximas a você poderão ter acesso ao suas informações de saúde,
            poderá ainda ver quem já visualizou seus registros eletrônicos de
            saúde no menu “Compartilhamento”.
          </p>
          <p className="lastParagraphPrivacy">
            Caso não deseje que seu registro de saúde seja compartilhado,
            selecione a opção “Não tenho interesse em compartilhar meu Registro
            Eletrônico de Saúde”.
          </p>
        </div>
        <div className="boldWarningPrivacy">
          Seu Registro Eletrônico de Saúde é privado. Para que você possa
          compartilhá-lo ou não com outras pessoas ou com estabelecimentos de
          saúde de seu interesse, selecione a opção desejada.
        </div>

        <div className="listButtonsPrivacy">
          <button
            disabled={isSharing !== null && !isSharing}
            className="cancelSharingButton"
            onClick={
              isSharing || isSharing === null ? handleNotSharingEvent : () => {}
            }
          >
            Não tenho interesse em compartilhar meu Registro Eletrônico de Saúde
          </button>
          <button
            className="consentSharingButton"
            disabled={isSharing !== null && isSharing}
            onClick={
              !isSharing || isSharing === null ? handleSharingEvent : () => {}
            }
          >
            Sim, desejo compartilhar meu Registro Eletrônico de Saúde
          </button>
        </div>
      </div>
    </>
  );
}
